import { personnelService } from '@/api/resources/personnelService'
import { commonSampleClassificationService } from '@/api/resources/common/sample-classification/sample-classification.service'
import registrySampleService from '@/modules/RegistryModule/services/sampleServices'
import { getSampleDeletionConfirmationMessage } from '@/api/resources/ConfirmationMessageResource'
import { cloneDeep, uniqBy, differenceWith, isEqual } from 'lodash'
import { store } from '@/store/store'
import apiExceptionType from '@/utils/apiExceptionType'
import sampleObservationsService from '@/api/resources/clob/SampleObservationsService'
import { SAMPLE_TYPE_WORKFLOW } from '@/api/resources/common/commonSampleService'
import { CommonResponsibilityCodeEnum } from '@/api/services/common/responsibility/common-responsibility.dto'
const LOAD_CASE_EMIT = 'load-case'
const LOAD_SAMPLES_EMIT = 'load-samples'
export default {
    data() {
        return {
            errorWhileSaving: false,
            topographicCodes: [],
            sampleTypes: [],
            mostLikelyDiagnoses: [],
            procedures: [],
            personnelPathologist: [],
            personnelResident: [],
            personnelGrossingControllers: [],
            personnelGrossingResponsible: [],
            personnelCytologyExperts: [],
            personnelGrossingCoordinators: [],
            personnelGrossingTutors: [],
            personnelProcessingCoordinators: [],
            personnelProcessingTutors: [],
            personnelProcessingControllers: [],
            personnelProcessingResponsible: [],
            showErrors: false,
            errorMessage: null,
            deleteSampleModalConfirmationMessage: this.$t('component.modalConfirmation.content')
        }
    },
    computed: {
        laboratoryId() {
            return store.getters.labId
        }
    },
    methods: {
        emitLoadSamples() {
            this.$emit(LOAD_SAMPLES_EMIT, this.samples)
        },
        cleanPersonnelsOfSample(sample) {
            sample.grossingCoorPerId = null
            sample.grossingCoorPerName = null
            sample.grossingResponsiblePerId = null
            sample.grossingResponsiblePerName = null
            sample.grossingTechPerId = null
            sample.grossingTechPerName = null
            sample.grossingTutorPerId = null
            sample.grossingTutorPerName = null
        },
        getPersonnelCoordinators(sample) {
            return sample.sampleTypeWorkflow === SAMPLE_TYPE_WORKFLOW.GROSSING_BIOPSIES.code
                ? this.getPersonnelGrossingCoordinators(sample) : this.getPersonnelProcessingCoordinators(sample)
        },
        getPersonnelTutors(sample) {
            return sample.sampleTypeWorkflow === SAMPLE_TYPE_WORKFLOW.GROSSING_BIOPSIES.code
                ? this.getPersonnelGrossingTutors(sample) : this.getPersonnelProcessingTutors(sample)
        },
        getPersonnelControllers(sample) {
            return sample.sampleTypeWorkflow === SAMPLE_TYPE_WORKFLOW.GROSSING_BIOPSIES.code
                ? this.getPersonnelGrossingControllers(sample) : this.getPersonnelProcessingControllers(sample)
        },
        getPersonnelResponsible(sample) {
            return sample.sampleTypeWorkflow === SAMPLE_TYPE_WORKFLOW.GROSSING_BIOPSIES.code
                ? this.getPersonnelGrossingResponsible(sample) : this.getPersonnelProcessingResponsible(sample)
        },
        async deleteSamplesBatch(samples) {
            const message = getSampleDeletionConfirmationMessage(samples)
            this.deleteSampleModalConfirmationMessage = message !== '' ? this.$tc(message) : ''

            this.$nextTick(async () => {
                const deleteConfirmation = await this.showConfirmationModalGlobal(this.deleteSampleModalConfirmationMessage)
                if (deleteConfirmation) {
                    await this.deleteSamplesBatchInternal(samples)
                }
            })
        },
        async deleteSamplesBatchInternal(samples) {
            this.updateLoading(true)
            let samplesToDelete = []
            let samplesToDeleteWithoutId = []
            samples.forEach((sample) => {
                if (sample.id) {
                    samplesToDelete.push(sample)
                } else {
                    samplesToDeleteWithoutId.push(sample)
                }
            })

            if (samplesToDelete.length > 0) {
                const [error, response] = await this.toCall(registrySampleService.deleteSamplesBatch(this.laboratoryId, this.casId, samplesToDelete))
                if (error) {
                    this.showErrorModalGlobalFromErrorResponse(error)
                    this.updateLoading(false)
                    return
                }
                if (response && response.length) {
                    let errorMessage = ''
                    response.forEach(elementWithError => {
                        errorMessage = errorMessage + `<p>${elementWithError.errorMessage}</p>`
                        samplesToDelete = samplesToDelete.filter((sample) => sample.id !== elementWithError.id)
                    })

                    this.showErrorModalGlobal(this.$t('registry.sampleGrid.error.errorDeleting') + `: ${errorMessage}`)
                }
                this.samples = this.samples.filter((sample) => !samplesToDelete.includes(sample))
                this.cloneSamples(this.samples)
                this.$emit(LOAD_CASE_EMIT)
            }
            if (samplesToDeleteWithoutId.length > 0) {
                this.samples = this.samples.filter((sample) => !samplesToDeleteWithoutId.includes(sample))
            }
            this.emitLoadSamples()
            this.selectedRows = []
            this.updateLoading(false)
        },
        hasSampleBeenChanged() {
            if (this.samples.length !== this.samplesClone.length) {
                return true
            }
            const samplesClone = this.samplesClone.map(sample => this.mapSampleToRequest(sample))
            const samples = this.samples.map(sample => this.mapSampleToRequest(sample))
            const hasNewSample = samples.some(sample => !sample.id)
            return hasNewSample || !isEqual(samplesClone, samples)
        },
        mapSampleToRequest(sample) {
            return {
                id: sample.id,
                originalConcurrencyUpdatedAt: sample.originalConcurrencyUpdatedAt,
                sampleTypeId: sample.sampleType ? sample.sampleType.id : null,
                topographicCodeId: sample.topographicCode ? sample.topographicCode.id : null,
                procedureId: sample.procedure ? sample.procedure.id : null,
                grossingCoordinatorId: sample.grossingCoordinator ? sample.grossingCoordinator.id : null,
                grossingResponsibleId: sample.grossingResponsible ? sample.grossingResponsible.id : null,
                grossingTechControllerId: sample.grossingTechController ? sample.grossingTechController.id : null,
                grossingTutorId: sample.grossingTutor ? sample.grossingTutor.id : null,
                specialistId: sample.specialist ? sample.specialist.id : null,
                pathologistId: sample.pathologist ? sample.pathologist.id : null,
                mostLikelyMorphologicCodeId: sample.mostLikelyMorphologicCode ? sample.mostLikelyMorphologicCode.id : null,
                observations: sample.observations,
                samplingDate: sample.samplingDate,
                conservation: sample.conservation,
                fragments: sample.fragments,
                sampleNumber: sample.sampleNumber,
                sampleOnSlide: sample.sampleOnSlide
            }
        },
        async saveSamples() {
            if (!this.hasSampleBeenChanged()) {
                return true
            }
            if (this.samples.length !== uniqBy(this.samples, 'sampleNumber').length) {
                this.showErrorModalGlobal(this.$t('registry.errors.duplicateLabel'))
                return false
            }
            const samplesToPost = []
            const samplesToPut = []
            let responsePost = null
            let errPost = null
            const samplesToSave =
                differenceWith(
                    this.samples,
                    this.samplesClone,
                    (value, other) => isEqual(value, other) && !!value.id)
            samplesToSave.forEach((sample) => {
                const sampleToSaveMapped = this.mapSampleToRequest(sample)
                sampleToSaveMapped.caseId = this.casId
                if (sampleToSaveMapped.id) {
                    samplesToPut.push(sampleToSaveMapped)
                } else {
                    sampleToSaveMapped.observations = sampleToSaveMapped.observations?.text
                    samplesToPost.push(sampleToSaveMapped)
                }
            })
            if (samplesToPost.length) {
                [errPost, responsePost] = await this.toCall(registrySampleService.createSample(this.laboratoryId, this.casId, samplesToPost))
                if (errPost) {
                    this.errorMessage = errPost.response.data.code === apiExceptionType.UNEXPECTED_SAMPLE_NUMBER ? errPost.response.data.message : this.$t('component.modalError.title')
                    this.showErrorModalGlobal(this.errorMessage)
                    this.updateLoading(false)
                    return false
                }
            }

            if (samplesToPut.length) {
                for (const sample of samplesToPut) {
                    const successfulObservationsUpdate = await this.updateObservations(sample)
                    if (!successfulObservationsUpdate) {
                        return false
                    }
                    const response = await this.$refs.samplesUpdateUtil.updateSample(this.laboratoryId, this.casId, sample.id, sample, registrySampleService)
                    if (response === null) {
                        this.updateLoading(false)
                        return false
                    }
                }
            }
            if ((samplesToPost.length && responsePost?.length) || samplesToPut.length) {
                if (this.sampleGrid) {
                    await this.loadSamples()
                } else {
                    this.$emit('updateSamples')
                }
                if (this.$options.name === 'ModalSamples') {
                    this.showToastSuccessGlobal(this.$t('registry.modal.sampleSaveSuccess'))
                }
            }
            return true
        },
        cloneSamples(samples) {
            this.samplesClone = cloneDeep(samples)
        },
        async getNextSamplesNumber(samplesNumber, numberOfSamples) {
            return registrySampleService.getNextSamplesNumbers(this.laboratoryId, this.casId, samplesNumber, numberOfSamples)
        },
        async getNextSamplesNumbersNoCase(samplesNumber, numberOfSamples) {
            return registrySampleService.getNextSamplesNumbers(this.laboratoryId, null, samplesNumber, numberOfSamples)
        },
        async loadSampleTypesOnChangeCaseType() {
            if (this.gridApi) {
                this.gridApi.refreshCells({ force: true })
            }
        },
        async loadTopographicCodes(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(commonSampleClassificationService.getCommonTopographicCodesSampleClassificationsByLaboratory(
                { laboratoryId: laboratoryId }
            ))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async loadSampleTypes(caseTypeId, sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(commonSampleClassificationService.getCommonSampleTypeSampleClassificationsByLaboratory(
                {
                    laboratoryId: laboratoryId,
                    caseTypeIds: [caseTypeId]
                }
            ))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async loadProcedures(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(commonSampleClassificationService.getCommonProceduresSampleClassificationsByLaboratory(
                { laboratoryId: laboratoryId }
            ))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async loadMostLikelyMorphologicCodes(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(commonSampleClassificationService.getCommonMostLikelyMorphologicCodesSampleClassificationsByLaboratory(
                { laboratoryId: laboratoryId }
            ))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async getPersonnelPathologist(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(personnelService.getPersonnelByLaboratoryAndResponsibility(laboratoryId, CommonResponsibilityCodeEnum.PATHOLOGIST))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async getPersonnelGrossingControllers(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(personnelService.getPersonnelByLaboratoryAndResponsibility(laboratoryId, CommonResponsibilityCodeEnum.GROSSING_CONTROLLER))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async getPersonnelGrossingResponsible(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(personnelService.getPersonnelByLaboratoryAndResponsibility(laboratoryId, CommonResponsibilityCodeEnum.GROSSING_RESPONSIBLE))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async getPersonnelCytologyExperts(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(personnelService.getPersonnelByLaboratoryAndResponsibility(laboratoryId, CommonResponsibilityCodeEnum.CYTOLOGY_EXPERT))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async getPersonnelGrossingCoordinators(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(personnelService.getPersonnelByLaboratoryAndResponsibility(laboratoryId, CommonResponsibilityCodeEnum.GROSSING_COORDINATOR))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async getPersonnelGrossingTutors(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(personnelService.getPersonnelByLaboratoryAndResponsibility(laboratoryId, CommonResponsibilityCodeEnum.GROSSING_TUTOR))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async getPersonnelProcessingCoordinators(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(personnelService.getPersonnelByLaboratoryAndResponsibility(laboratoryId, CommonResponsibilityCodeEnum.PROCESSING_COORDINATOR))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async getPersonnelProcessingTutors(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(personnelService.getPersonnelByLaboratoryAndResponsibility(laboratoryId, CommonResponsibilityCodeEnum.PROCESSING_TUTOR))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async getPersonnelProcessingControllers(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(personnelService.getPersonnelByLaboratoryAndResponsibility(laboratoryId, CommonResponsibilityCodeEnum.PROCESSING_CONTROLLER))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async getPersonnelProcessingResponsible(sample) {
            const laboratoryId = sample.currentLaboratory?.labId ?? this.laboratoryId
            const [err, response] = await this.toCall(personnelService.getPersonnelByLaboratoryAndResponsibility(laboratoryId, CommonResponsibilityCodeEnum.PROCESSING_RESPONSIBLE))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        async updateObservations(sample) {
            const originalSample = this.samplesClone.find(clone => clone.id === sample.id)
            if (sample.observations?.text === originalSample?.observations?.text) {
                return true
            }

            let [err, response] = await this.toCall(sampleObservationsService.update(this.labId, this.casId, sample.id, sample.observations))
            if (err) {
                if (err.response && err.response.data && err.response.data.code === this.$apiExceptions.CONCURRENCY_ERROR) {
                    this.updateLoading(false)
                    return this.processBasicConcurrencyConflict(this.$t('global.observations'), err, async () => {
                        sample.observations.originalConcurrencyUpdatedAt = err.response.data.currentConcurrencyUpdatedAt
                        this.updateLoading(true)
                        return this.updateObservations(sample)
                    })
                } else {
                    this.showErrorModalGlobal(this.$t('registry.modal.sampleSaveError'))
                    this.updateLoading(false)
                    return false
                }
            }
            originalSample.observations = response
            sample.observations = response
            return true
        }
    }
}
